module.exports = __webpack_public_path__ + "img/Mb_Lobby_Video.03e4a508.png";